let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kUgx3")).then(() => parcelRequire('hUelS'));